export class TrainingCertificateDto {
  constructor(dto) {
    this.id = dto.id;
    this.registration_id = dto.registration_id;
    this.code = dto.code;
    this.certificate_id = dto.certificate_id;
    this.create_date = dto.create_date;
    this.certificate = dto.certificate;
  }
}
